import { SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import s from './SkeletonBar.scss';
export const SkeletonBar = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React.createElement(SkeletonRectangle, {
    width: width,
    height: height,
    className: s.bar
  });
};
//# sourceMappingURL=SkeletonBar.js.map